import { useEffect, useRef } from 'react';
import { EMS_CSS, EMS_HTML, initEms } from './emsSource';
import { LEGACY_LIGHT_THEME } from '../legacyLightTheme';
import { enhanceLegacyInteractions } from '../enhanceLegacyInteractions';
import { useTheme } from '../../contexts/ThemeContext';
import { useAuth } from '../../contexts/AuthContext';

// Native React EMS dashboard (PR2 — replaces the former iframe).
// The original standalone app's CSS + markup + logic run verbatim inside a
// Shadow DOM: styles are fully isolated from the shell, and the ported script
// (see emsSource.js) drives the markup exactly as it did as a standalone page.
export default function EmsDashboard() {
  const hostRef = useRef(null);
  const { resolvedTheme } = useTheme();
  const { currentUser } = useAuth();

  useEffect(() => {
    const host = hostRef.current;
    if (!host) return;
    const root = host.shadowRoot || host.attachShadow({ mode: 'open' });
    root.innerHTML = `<style>${EMS_CSS}\n${LEGACY_LIGHT_THEME}</style>` + EMS_HTML;
    const cleanupInteractions = enhanceLegacyInteractions(root);
    initEms(root, currentUser?.kamFirstName || null);
    // Keep the detached tree alive until its in-flight requests settle. Clearing it
    // synchronously caused late EMS DOM updates to throw while another route mounted.
    return () => { cleanupInteractions(); };
  }, []);

  return <div className="ems-host" data-theme={resolvedTheme} ref={hostRef} />;
}
